import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { BookOpen, FileCheck, Landmark, Wallet, Users, Lightbulb } from "lucide-react";

const LESSONS = [
  { icon: FileCheck, title: "Get your EIN in 15 minutes", body: "Free from the IRS. Required for every federal grant. Step-by-step walkthrough." },
  { icon: Landmark, title: "Register on SAM.gov & Grants.gov", body: "Free federal registration. Most first-timers hit the same 3 rejection traps — we skip them." },
  { icon: Wallet, title: "Build a 3-year budget spreadsheet", body: "Templates for personnel, fringe, indirect costs and match. Copy-paste into Excel or Google Sheets." },
  { icon: Users, title: "501(c)(3) status for nonprofits", body: "IRS Form 1023-EZ vs 1023 — which one you actually need and how to file it right." },
  { icon: Lightbulb, title: "Anatomy of a winning narrative", body: "Statement of Need, Goals, Activities, Evaluation — reviewer psychology, section by section." },
  { icon: BookOpen, title: "How to read a grant announcement", body: "Decode CFR references, eligibility clauses and 'preference' language funders use to score." },
];

export default function Academy() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <section className="max-w-7xl mx-auto px-5 lg:px-8 py-14">
        <div className="overline mb-3">ACADEMY</div>
        <h1 className="font-display text-4xl md:text-6xl font-bold tracking-tight" data-testid="academy-title">Learn the paperwork the way funders read it.</h1>
        <p className="mt-4 text-neutral-600 max-w-2xl text-lg">Short, actionable lessons for founders and executive directors. No fluff, no "storytelling" theatre — just the docs and dollars.</p>

        <div className="mt-12 grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {LESSONS.map((l, i) => {
            const Icon = l.icon;
            return (
              <div key={i} className="gf-card p-6" data-testid={`lesson-${i}`}>
                <div className="h-11 w-11 rounded-lg bg-[color:var(--accent)]/10 text-[color:var(--accent)] flex items-center justify-center mb-4"><Icon size={20} /></div>
                <h3 className="font-display text-xl font-semibold mb-2">{l.title}</h3>
                <p className="text-sm text-neutral-600 leading-relaxed mb-4">{l.body}</p>
                <button className="btn-ghost text-sm" data-testid={`lesson-cta-${i}`}>Start lesson</button>
              </div>
            );
          })}
        </div>

        <div className="mt-16 rounded-2xl bg-neutral-900 text-white p-10 lg:p-14">
          <div className="max-w-2xl">
            <div className="overline text-white/70">COMING SOON</div>
            <h2 className="font-display text-3xl md:text-4xl font-bold tracking-tight mt-2">Live workshops with in-house grant writers.</h2>
            <p className="mt-3 text-white/85">Every month, ask questions live and get your draft reviewed. Included in Pro membership.</p>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}
